import * as React from 'react'
import styled from 'styled-components'
import AccountDashboard from 'theme/app/AccountDashboard'
import useAccount from 'hooks/account/useAccount'
import theme from 'theme'
import CartPreview from './CartPreview'
import LastOrderedProducts from './LastOrderedProducts'
import LastSeenProducts from './LastSeenProducts'
import ContactBox from 'theme/templates/account/Dashboard/ContactBox'
import useCart from 'hooks/account/cart/useCart'
import withTranslations from './withTranslations'
import useTranslations from 'hooks/useTranslations'
import Seo from 'theme/atoms/SEO'
import config from 'config'
import useSalutationList from 'hooks/account/lists/useSalutationList'
import Link from 'theme/atoms/Link'

type Props = {
  location: {
    pathname: string
    origin: string
    hash: string
  }
}

export function Dashboard(props: Props) {
  const account = useAccount()
  const cart = useCart()
  const t = useTranslations<'account-Dashboard'>()
  const salutations = useSalutationList()

  const firstName =
    account.context?.firstName ||
    account.context?.defaultBillingAddress.firstName ||
    ''

  const lastName =
    account.context?.lastName ||
    account.context?.defaultBillingAddress.lastName ||
    ''

  const greetingSnippet = () => {
    switch (account.context?.salutationId) {
      case salutations.data[0]?.id:
        return t('dashboard_greeting_male', { name: lastName })
      case salutations.data[1]?.id:
        return t('dashboard_greeting_female', { name: lastName })
      default:
        return t('dashboard_greeting', {
          name: firstName + ' ' + lastName
        })
    }
  }

  const description = (
    <Description>
      <p>{t('dashboard_info_text_greeting')}</p>
      <p>
        {t('dashboard_info_text', {
          LINK: '-',
          __transformers: {
            LINK: (_, vars) => (
              <Link className="description-link" to={vars.LINK_link}>
                {vars.LINK_label}
              </Link>
            )
          }
        })}
      </p>
    </Description>
  )

  return (
    <AccountDashboard
      data-cy-ctx="templates/account/Dashboard"
      activePage="dashboard"
      title={greetingSnippet()}
      description={description}
      breadcrumbs={[
        { label: t('dashboard_breadcrumb_home'), link: '/' },
        { label: t('dashboard_breadcrumb_my_account') }
      ]}
    >
      <Seo
        canonicalUrl={`${config.baseUrl}${props.location.pathname}`}
        location={props.location}
        title={t.asText(false, 'dashboard_breadcrumb_my_account')}
        description=""
        type="website"
      />
      <Wrapper className="Dashboard">
        {cart.data.items.length > 0 && (
          <CartPreview data-cy-state="show-cart-preview" />
        )}
        <LastOrderedProducts />
        <LastSeenProducts />
        <ContactBox />
      </Wrapper>
    </AccountDashboard>
  )
}

export default withTranslations(Dashboard)

const Wrapper = styled.div`
  > .CartPreview {
    margin-bottom: ${theme.spacing('l')};
  }
  > .LastOrderedProducts {
    margin-bottom: ${theme.spacing('l')};
  }
  > .LastSeenProducts {
    margin-bottom: ${theme.spacing('l')};
  }
`

const Description = styled.div`
  gap: ${theme.spacing('m')};
  > p {
    ${theme.ty('rc-base')};
  }
`
